import React from 'react';
import { GTINFilterCheckbox } from './gtin-filter-checkbox';
import { Props as ListItemProps, ListOption } from '@/components/list-item';
import { MaybeScrollingList } from '@/components/maybe-scrolling-list';
import { StyleProp, StyleSheet, Text, View, ViewStyle } from 'react-native';
import { TYPOGRAPHY } from '@/styles';

interface Props {
  contentContainerStyle?: StyleProp<ViewStyle>;
  listItemStyle?: StyleProp<ViewStyle>;
  options: ListOption[];
  scrollEnabled?: boolean;
  selectedValues: Set<string>;
  setSelectedValues: React.Dispatch<React.SetStateAction<Set<string>>>;
}

export const CheckboxList: React.FC<Props> = ({
  contentContainerStyle,
  listItemStyle,
  options,
  selectedValues,
  setSelectedValues,
  scrollEnabled = false,
}) => {
  const onItemSelect = (value: string) => {
    setSelectedValues((prev) => {
      const next = new Set(prev);
      if (next.has(value)) {
        next.delete(value);
      } else {
        next.add(value);
      }
      return next;
    });
  };

  const sharedProps: Partial<ListItemProps<ListOption>> = {
    listItemStyle: [styles.listItem, listItemStyle],
    onSelect: (option) => {
      onItemSelect(String(option.value));
    },
    renderLeftComponent: (option) => (
      <GTINFilterCheckbox
        isSelected={selectedValues.has(String(option.value))}
        onSelect={() => {
          onItemSelect(String(option.value));
        }}
      />
    ),
    renderMainContent: (option) => (
      <View style={styles.mainContent}>
        <Text style={TYPOGRAPHY.medium}>{option.title}</Text>
      </View>
    ),
  };

  return (
    <MaybeScrollingList<ListOption>
      data={options}
      listProps={{
        ItemSeparatorComponent: null,
      }}
      scrollEnabled={scrollEnabled}
      sharedProps={sharedProps}
      style={contentContainerStyle}
    />
  );
};

const styles = StyleSheet.create({
  listItem: {
    paddingVertical: 4,
  },
  mainContent: {
    flex: 1,
  },
});
